import React from "react";
import "./Rodape.css";
import HorarioAtendimento from "../HorarioAtendimento";

//import { House, ListNested, Building, PersonLinesFill, Youtube, Facebook, Instagram, Clock, Telephone, Envelope } from 'react-bootstrap-icons';

const Rodape = () => {
    return (
        <>
            <HorarioAtendimento />
            <div className="rodape">
                <div className="conteudo">
                Copyright © 2025  Construmarcas - Todos os direitos reservados
                </div>
            </div>
        </>
    )
}

export default Rodape;